const cabinets = [
    {
        id: 1,
        cabinetId: '079642-7610',
        name: {
            text: 'Betatech',
            color: '#f0483a'
        },
        admin: 'Danny Osborne',
        contractStart: '2018-08-13T11:22:55.416Z',
        contractEnd: '2019-08-13T11:22:55.416Z',
        updatedAt: '2018-08-17T11:22:55.416Z',
        advisors: ['conseiller1', 'conseiller2', 'conseiller3'],
        clients: ['client1', 'client2', 'client3', 'client4'],
        available: true
    },
    {
        id: 2,
        cabinetId: '859400-7610',
        name: {
            text: 'Cancity',
            color: '#feb93d'
        },
        admin: 'Angel Cooper',
        contractStart: '2018-08-13T11:22:55.416Z',
        contractEnd: '2019-08-13T11:22:55.416Z',
        updatedAt: '2018-08-17T11:22:55.416Z',
        advisors: ['conseiller1', 'conseiller2', 'conseiller3', 'conseiller2', 'conseiller3'],
        clients: ['client1', 'client2', 'client3', 'client4'],
        available: false
    },
    {
        id: 3,
        cabinetId: '598498-7610',
        name: {
            text: 'Kontmatfix',
            color: '#a0ac47'
        },
        admin: 'Tayler Haynes',
        contractStart: '2018-08-13T11:22:55.416Z',
        contractEnd: '2019-08-13T11:22:55.416Z',
        updatedAt: '2018-08-17T11:22:55.416Z',
        advisors: ['conseiller1', 'conseiller2'],
        clients: ['client1', 'client2'],
        available: true
    },
    {
        id: 4,
        cabinetId: '059393-7610',
        name: {
            text: 'Aquilogia',
            color: '#ffda00'
        },
        admin: 'Jason Aguilar',
        contractStart: '2018-08-13T11:22:55.416Z',
        contractEnd: '2019-08-13T11:22:55.416Z',
        updatedAt: '2018-08-17T11:22:55.416Z',
        advisors: ['conseiller1'],
        clients: ['client1', 'client2', 'client3'],
        available: false
    },
    {
        id: 5,
        cabinetId: '958433-7610',
        name: {
            text: 'Iselectrics',
            color: '#0ecc48'
        },
        admin: 'Harry Mathis',
        contractStart: '2018-08-13T11:22:55.416Z',
        contractEnd: '2019-08-13T11:22:55.416Z',
        updatedAt: '2018-08-17T11:22:55.416Z',
        advisors: ['conseiller1', 'conseiller2', 'conseiller3'],
        clients: ['client1', 'client2', 'client3', 'client4'],
        available: true
    }
]

export default cabinets


// WEBPACK FOOTER //
// ./src/fixtures/cabinets.js